import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/utilities/cn-utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "rounded border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "rounded border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "rounded border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        month: "text-white bg-primary border-none h-6 text-[10px] font-bold",
        calendar: "bg-[#F4F7FE] text-[#A3AED0] items-center justify-center border-none h-6 gap-1 text-xs py-4",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
